import { PatientConsentViewModel } from "./PatientConsentViewModel";
const WelcomePageAnalyticsEvent = {
    WELCOME_PAGE_VIEWED: "WelcomePageViewed",
    WELCOME_PAGE_GET_STARTED_CLICKED: "WelcomePageGetStartedClicked",
};
export class PatientConsentWelcomeViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.trackWelcomePageViewed();
    }
    goToNextPage() {
        this.trackWelcomePageGetStartedClicked();
        super.goToNextPage();
    }
    trackWelcomePageViewed() {
        const { identity, user_id, properties } = this.getCommonHeapAttributes();
        if (!navigator.webdriver) {
            void this.analyticsService.trackHeapEvent({
                event: WelcomePageAnalyticsEvent.WELCOME_PAGE_VIEWED,
                identity,
                user_id,
                properties,
            });
        }
    }
    trackWelcomePageGetStartedClicked() {
        const { identity, user_id, properties } = this.getCommonHeapAttributes();
        if (!navigator.webdriver) {
            void this.analyticsService.trackHeapEvent({
                event: WelcomePageAnalyticsEvent.WELCOME_PAGE_GET_STARTED_CLICKED,
                identity,
                user_id,
                properties: { ...properties, buttonText: this.pddeGDUWelcomeConfirmButtonText },
            });
        }
    }
}
